var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-page page"},[_c('div',{staticClass:"static-page__container"},[_c('h1',{staticClass:"static-page__title"},[_vm._v(_vm._s(_vm.page.title))]),(_vm.page.description)?_c('div',{staticClass:"static-page__description"},[_c('EditorJSComponent',{attrs:{"text":JSON.parse(_vm.page.description)}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }